import PropTypes from 'prop-types';

// Utils
import { actionHandler } from '../../utilities/form/formUtils';

// Components
import Text from '../Global/Text';

const Label = ({
  id,
  label,
  className,
  actions,
  dispatch,
  setValues,
  values,
  toolTip,
  numberFormat,
  tabIndex,
}) => (
  <label
    className={className || 'form__label'}
    htmlFor={id}
    key={label}
  >
    {actions &&
    <button
      type="button"
      className="label__action button button--text button-shadow-dom"
      onClick={e => actionHandler(actions, null, e, dispatch, values, setValues)}
      aria-label="label action"
      tabIndex={tabIndex}
    >
      <Text value={label} numberFormat={numberFormat} toolTip={toolTip}/>
    </button>
    }
    {!actions &&
    <Text value={label} numberFormat={numberFormat} toolTip={toolTip}/>
    }
  </label>
);

export default Label;

Label.defaultProps = {
  className: null,
  actions: null,
  dispatch: null,
  toolTip: null,
  numberFormat: false,
  tabIndex: 0
};

Label.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  dispatch: PropTypes.func,
  actions: PropTypes.array,
  className: PropTypes.string,
  toolTip: PropTypes.string,
  setValues: PropTypes.func,
  values: PropTypes.object,
  numberFormat: PropTypes.bool,
  tabIndex: PropTypes.number
};